import { sanitizeNoteHtml } from 'dashboard409a/components/ValuationsTable/common/AnalystNoteHtml.utilities';

const NOTE_PREVIEW_MAX_LENGTH = 140;
const NOTE_IMAGE_PLACEHOLDER = '*image\u00A0';

export const buildLatestNotePreviewHtml = (html: string, maxLength: number = NOTE_PREVIEW_MAX_LENGTH) => {
  if (!html || typeof window === 'undefined') {
    return '';
  }

  const sanitizedHtml = sanitizeNoteHtml(html);
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHtml, 'text/html');

  doc.querySelectorAll('img').forEach(imageNode => {
    imageNode.replaceWith(doc.createTextNode(NOTE_IMAGE_PLACEHOLDER));
  });

  let remainingCharacters = maxLength;
  let isTruncated = false;

  const truncateNode = (node: Node): Node | null => {
    if (remainingCharacters <= 0) {
      isTruncated = true;
      return null;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent ?? '';

      if (text.length <= remainingCharacters) {
        remainingCharacters -= text.length;
        return doc.createTextNode(text);
      }

      const truncatedText = text.slice(0, remainingCharacters);
      remainingCharacters = 0;
      isTruncated = true;
      return doc.createTextNode(truncatedText);
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return null;
    }

    const element = node as HTMLElement;
    const clonedElement = element.cloneNode(false) as HTMLElement;

    Array.from(element.childNodes).forEach(childNode => {
      const truncatedChild = truncateNode(childNode);
      if (truncatedChild) {
        clonedElement.appendChild(truncatedChild);
      }
    });

    if (clonedElement.childNodes.length === 0 && element.tagName.toLowerCase() !== 'br') {
      return null;
    }

    return clonedElement;
  };

  const previewWrapper = doc.createElement('div');

  Array.from(doc.body.childNodes).forEach(childNode => {
    const truncatedChild = truncateNode(childNode);
    if (truncatedChild) {
      previewWrapper.appendChild(truncatedChild);
    }
  });

  if (isTruncated) {
    previewWrapper.appendChild(doc.createTextNode('…'));
  }

  return sanitizeNoteHtml(previewWrapper.innerHTML);
};
